import React from "react";
import "../styles/OurTeam.css";

const teamMembers = [
  {
    name: "Selvamani S",
    title: "Assistant Manager HR",
      image: "/assets/team/selvamani.jpg",
    linkedin: "https://linkedin.com/in/selvamanihr",
  },
  {
    name: "Keerthana K",
    title: "Senior - TA",
      image: "/assets/team/keerthana.jpg",
    linkedin: "https://linkedin.com/in/keerthana-k-2b9004250",
  },
  {
    name: "Judith Asmi",
    title: "Talent Acquisition Specialist",
      image: "/assets/team/judith.jpg",
    linkedin: "https://linkedin.com/in/judithasmi",
  },
  {
    name: "Baranidharan M",
    title: "Software Engineer",
      image: "/assets/team/bharani.jpeg",
    linkedin: "https://linkedin.com/in/baranidharan-murugesan-458209371",
  },
  {
    name: "Sanjay M",
    title: "UX/UI Designer",
      image: "/assets/team/sanjay.jpg",
    linkedin: "https://linkedin.com/in/sanjaymagendramani",
  },
  {
    name: "Praveen S",
    title: "Junior Software Engineer",
      image: "/assets/team/praveen.jpg",
    linkedin: "https://linkedin.com/in/praveen-samiayya-242a27250",
  },
  {
    name: "Janarthan G",
    title: "Junior Software Engineer",
      image: "/assets/team/jana.jpeg",
    linkedin: "https://www.linkedin.com/in/janarthan-g-988505281",
  },
 
];

export default function OurTeam() {
  return (
    <section className="team-section">
      <h2 className="team-title">People & Culture</h2>
      <p className="team-subtitle">
        A team culture built on understanding, innovation, and customization.
      </p>
      <div className="team-grid">
        {teamMembers.map((member, idx) => (
          <div className="team-card" key={idx}>
            <div className="team-photo-wrapper">
              <img src={member.image} alt={member.name} className="team-photo" />
            </div>
            <div className="team-info">
              <div className="team-name-row">
                <span className="team-name">{member.name}</span>
                <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-icon">
                  <img src="/assets/icons/linkedin2.png" alt="LinkedIn" width={28} height={28} />
                </a>
              </div>
              <span className="team-title-job">{member.title}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
